import React, { useEffect, useRef, useState } from 'react'
import "../hackathon/swiper.css";
import "./hackathonCollege.css";

const videoArr = {
    "grainDispenser": 'https://player.vimeo.com/video/909027435?h=636e516fd5&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
    "medicineDispenser": 'https://player.vimeo.com/video/1023868523?h=1d0eb7eb03&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
    "smartHealthcare": 'https://player.vimeo.com/video/1006915556?h=bafe32d073&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
    "petFeeder": 'https://player.vimeo.com/video/1031881946?h=5b33fa5e1d&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
};



const HackathonCollege = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleAbout = (e) => {
        e.stopPropagation();
        setIsOpen(!isOpen);
    };

    const hideModal = () => {
        document.getElementById("modal01").style.display = "none";
    }

    const onClick = (elementId) => {
        const videoUrl = videoArr[elementId];
        if (videoUrl) {
            document.getElementById("img01").src = videoUrl;
            document.getElementById("modal01").style.display = "block";
        }
    };

    useEffect(() => {
        const swiper = new window.Swiper('.swiper', {
            loop: true,
            slidesPerView: 'auto',
            spaceBetween: 33,
            centeredSlides: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            scrollbar: {
                el: '.swiper-scrollbar',
            },
        });
        const handleClickOutside = () => {
            setIsOpen(false);
        };
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);
    return (
        <div class="mdl-layout mdl-js-layout mdl-layout--fixed-header hackathon-bg-color">
            <div class="android-header mdl-layout__header mdl-layout__header--waterfall" style={{ position: "fixed", height: "100px" }}>
                <div class="mdl-layout__header-row title-bar" style={{ marginTop: "5px" }}>
                    <span class="android-title mdl-layout-title">
                        <img class="android-logo-image" src="https://s3.amazonaws.com/s3-grok-cloodon-com/logo.png" />
                    </span>
                    {/* <!-- Add spacer, to align navigation to the right in desktop --> */}
                    {/* <!-- <div class="android-header-spacer mdl-layout-spacer"></div> --> */}
                    <div class="android-title android-section-title mdl-typography--display-1-color-contrast title-bar-text" style={{ color: "#585656", fontSize: "39px", marginBottom: "10px" }}>IoT Projects powered by Grovator®</div>
                    {/* <!-- <div class="android-navigation-container">
                        <nav class="android-navigation mdl-navigation">
                        <a class="mdl-navigation__link mdl-typography--text-uppercase" href="">Link1</a>
                        <a class="mdl-navigation__link mdl-typography--text-uppercase" href="">Link2</a>
                        <a class="mdl-navigation__link mdl-typography--text-uppercase" href="">Link3</a>
                        <a class="mdl-navigation__link mdl-typography--text-uppercase" href="">Link4</a>
                        <a class="mdl-navigation__link mdl-typography--text-uppercase" href="">Link5</a>
                        <a class="mdl-navigation__link mdl-typography--text-uppercase" href="">Link6</a>
                        <a class="mdl-navigation__link mdl-typography--text-uppercase" href="">Link7</a>
                        </nav>
                        </div> --> */}
                    <span class="android-mobile-title mdl-layout-title ">
                        <img class="android-logo-image" src="https://s3.amazonaws.com/s3-grok-cloodon-com/logo.png" />
                    </span>
                    <div style={{ position: 'relative' }}>
                        {/* More button */}
                        <button onClick={toggleAbout} style={{ cursor: 'pointer', background: "none", border: "none" }}>
                            <i className="material-icons">more_vert</i>
                        </button>

                        {/* Dropdown Menu */}
                        {isOpen && (
                            <ul style={{
                                position: 'absolute',
                                top: '40px',
                                width: "100px",
                                right: 0,
                                backgroundColor: '#fff',
                                border: '1px solid #ccc',
                                padding: '10px',
                                zIndex: 10,
                            }}>
                                <li>
                                    <a href="https://www.grovator.com/" target='_blank' style={{ textDecoration: 'none', color: '#333' }}>About us</a>
                                </li>
                            </ul>
                        )}
                    </div>
                </div>
            </div>

            <div class="page-title-section">
                <div class="mobile-text android-section-title mdl-typography--display-1-color-contrast mobile-title-text" style={{ color: "red" }}>IoT Projects powered by Grovator®</div>
            </div>


            <div class="android-content mdl-layout__content" style={{ marginTop: "70px" }}>
                <a name="top"></a>
                <div class="android-be-together-section mdl-typography--text-center">
                    <div class="swiper">
                        {/* <!-- Slider main container --> */}
                        {/* <!-- Additional required wrapper --> */}
                        <div class="swiper-wrapper">
                            {/* <!-- Slides --> */}
                            <div class="swiper-slide">
                                {/* <!-- <h3><span class="slides2pan">Waste Management<small>Smart City</small></span></h3> --> */}
                                <div class="slider-video">
                                    <div style={{ padding: '56.25% 0 0 0', position: 'relative' }}><iframe src="https://player.vimeo.com/video/909027435?h=636e516fd5&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }} title="Smart Waste Management System_Without Music_V02"></iframe></div>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                {/* <!-- <h3><span class="slides2pan">Energy Saving<small>Smart Home</small></span></h3> --> */}
                                <div class="slider-video">
                                    <div style={{ padding: '56.25% 0 0 0', position: 'relative' }}><iframe src="https://player.vimeo.com/video/1023868523?h=1d0eb7eb03&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }} title="Energy Saving - smart home"></iframe></div>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                {/* <!-- <h3><span class="slides2pan">Green Roofs/Verticle gardens<small>Smart City</small></span></h3> --> */}
                                <div class="slider-video">
                                    <div style={{ padding: '56.25% 0 0 0', position: 'relative' }}><iframe src="https://player.vimeo.com/video/1006915556?h=bafe32d073&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }} title="Monitoring Green Roofs and Vertical Gardens"></iframe></div>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                {/* <!-- <h3><span class="slides2pan">Air Quality Monitoring<small>Smart City</small></span></h3> --> */}
                                <div class="slider-video">
                                    <div style={{ padding: '56.25% 0 0 0', position: 'relative' }}><iframe src="https://player.vimeo.com/video/1031881946?h=5b33fa5e1d&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }} title="Air Quality Monitoring"></iframe></div>
                                </div>
                            </div>
                        </div>
                        {/* <!-- If we need navigation buttons --> */}
                        <div class="swiper-button-prev">
                            <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="4em" width="2em" xmlns="http://www.w3.org/2000/svg"><path d="M217.9 256L345 129c9.4-9.4 9.4-24.6 0-33.9-9.4-9.4-24.6-9.3-34 0L167 239c-9.1 9.1-9.3 23.7-.7 33.1L310.9 417c4.7 4.7 10.9 7 17 7s12.3-2.3 17-7c9.4-9.4 9.4-24.6 0-33.9L217.9 256z"></path></svg></span>
                        </div>
                        <div class="swiper-button-next">
                            <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="4em" width="2em" xmlns="http://www.w3.org/2000/svg"><path d="M294.1 256L167 129c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.3 34 0L345 239c9.1 9.1 9.3 23.7.7 33.1L201.1 417c-4.7 4.7-10.9 7-17 7s-12.3-2.3-17-7c-9.4-9.4-9.4-24.6 0-33.9l127-127.1z"></path></svg></span>
                        </div>
                        {/* <!-- <div class="swiper-scrollbar"></div> --> */}
                    </div>
                </div>

                {/* Start More Section */}
                <div class="android-more-section">
                    <a name="screens"></a>
                    <div class="android-section-title mdl-typography--display-1-color-contrast">Student's Acheivements</div>
                    <p class="mdl-typography--headline mdl-typography--font-thin mob-info" style={{ marginLeft: "12px" }}>Students trained on the Grovator platform have built these solutions, addressing real-world challenges and implementing their ideas. Their innovative projects helped them to showcase their creativity and problem-solving skills.</p>
                    <div class="android-card-container mdl-grid">
                    </div>
                    {/* <div class="mdl-cell mdl-cell--12-col mdl-cell--4-col-tablet mdl-cell--4-col-phone mdl-card mdl-shadow--3dp">
                    <div class="mdl-card__media">
                        <img id="smartHealthcare" src="images/3.jpg" style="width:100%;cursor:pointer" onclick="onClick(this)">
                    </div>
                    <div class="mdl-card__supporting-text">
                    </div>
                    <div class="mdl-card__actions">
                        <a id="smartHealthcare" class="android-link mdl-button mdl-js-button mdl-typography--text-uppercase"  onclick="onClick(this)">
                        Watch Now
                        <i class="material-icons">play_arrow</i>
                        </a>
                    </div>
                    </div>
                    <div class="mdl-cell mdl-cell--12-col mdl-cell--4-col-tablet mdl-cell--4-col-phone mdl-card mdl-shadow--3dp">
                    <div class="mdl-card__media">
                        <img id="LPGSafety" src="images/6.jpg" style="width:100%;cursor:pointer" onclick="onClick(this)">
                    </div>
                    <div class="mdl-card__supporting-text">
                    </div>
                    <div class="mdl-card__actions">
                        <a id="LPGSafety" class="android-link mdl-button mdl-js-button mdl-typography--text-uppercase"  onclick="onClick(this)">
                        Watch Now
                        <i class="material-icons">play_arrow</i>
                        </a>
                    </div>
                    </div>
                    <div class="mdl-cell mdl-cell--12-col mdl-cell--4-col-tablet mdl-cell--4-col-phone mdl-card mdl-shadow--3dp">
                    <div class="mdl-card__media">
                        <img id="AgriFence" src="images/7.jpg" style="width:100%;cursor:pointer" onclick="onClick(this)">
                    </div>
                    <div class="mdl-card__supporting-text">
                    </div>
                    <div class="mdl-card__actions">
                        <a id="AgriFence" class="android-link mdl-button mdl-js-button mdl-typography--text-uppercase"  onclick="onClick(this)">
                        Watch Now
                        <i class="material-icons">play_arrow</i>
                        </a>
                    </div>
                    </div>
                    <div class="mdl-cell mdl-cell--12-col mdl-cell--4-col-tablet mdl-cell--4-col-phone mdl-card mdl-shadow--3dp">
                    <div class="mdl-card__media">
                        <img id="smartHelmet" src="images/8.jpg" style="width:100%;cursor:pointer" onclick="onClick(this)">
                    </div>
                    <div class="mdl-card__supporting-text">
                    </div>
                    <div class="mdl-card__actions">
                        <a id="smartHelmet" class="android-link mdl-button mdl-js-button mdl-typography--text-uppercase"  onclick="onClick(this)">
                        Watch Now
                        <i class="material-icons">play_arrow</i>
                        </a>
                    </div>
                </div> */}
                    <div class="mdl-cell mdl-cell--12-col mdl-cell--4-col-tablet mdl-cell--4-col-phone mdl-card mdl-shadow--3dp">
                        <div class="mdl-card__media">
                            <img id="grainDispenser" src={require('../../images/college1.jpg')} style={{ width: "100%", cursor: "pointer" }} onClick={() => onClick('grainDispenser')} />
                        </div>
                        <div class="mdl-card__supporting-text">
                        </div>
                        <div class="mdl-card__actions">
                            <a id="grainDispenser" class="android-link mdl-button mdl-js-button mdl-typography--text-uppercase" onClick={() => onClick('grainDispenser')}>
                                Watch Now
                                <i class="material-icons">play_arrow</i>
                            </a>
                        </div>
                    </div>
                    <div class="mdl-cell mdl-cell--12-col mdl-cell--4-col-tablet mdl-cell--4-col-phone mdl-card mdl-shadow--3dp">
                        <div class="mdl-card__media">
                            <img id="medicineDispenser" src={require('../../images/college2.jpg')} style={{ width: "100%", cursor: "pointer" }} onClick={() => onClick('medicineDispenser')} />
                        </div>
                        <div class="mdl-card__supporting-text">
                        </div>
                        <div class="mdl-card__actions">
                            <a id="medicineDispenser" class="android-link mdl-button mdl-js-button mdl-typography--text-uppercase" onClick={() => onClick('medicineDispenser')}>
                                Watch Now
                                <i class="material-icons">play_arrow</i>
                            </a>
                        </div>
                    </div>
                    <div class="mdl-cell mdl-cell--12-col mdl-cell--4-col-tablet mdl-cell--4-col-phone mdl-card mdl-shadow--3dp">
                        <div class="mdl-card__media">
                            <img id="smartHealthcare" src={require('../../images/college3.jpg')} style={{ width: "100%", cursor: "pointer" }} onClick={() => onClick('smartHealthcare')} />
                        </div>
                        <div class="mdl-card__supporting-text">
                        </div>
                        <div class="mdl-card__actions">
                            <a id="smartHealthcare" class="android-link mdl-button mdl-js-button mdl-typography--text-uppercase" onClick={() => onClick('smartHealthcare')}>
                                Watch Now
                                <i class="material-icons">play_arrow</i>
                            </a>
                        </div>
                    </div>
                    <div class="mdl-cell mdl-cell--12-col mdl-cell--4-col-tablet mdl-cell--4-col-phone mdl-card mdl-shadow--3dp">
                        <div class="mdl-card__media">
                            <img id="petFeeder" src={require('../../images/college4.jpg')} style={{ width: "100%", cursor: "pointer" }} onClick={() => onClick('petFeeder')} />
                        </div>
                        <div class="mdl-card__supporting-text">
                        </div>
                        <div class="mdl-card__actions">
                            <a id="petFeeder" class="android-link mdl-button mdl-js-button mdl-typography--text-uppercase" onClick={() => onClick('petFeeder')}>
                                Watch Now
                                <i class="material-icons">play_arrow</i>
                            </a>
                        </div>
                    </div>
                </div>

                {/* <!-- End More Section --> */}
                {/* <!-- Modal-section Begin --> */}
                <div id="modal01" class="w3-modal" onClick={hideModal}>
                    <span class="w3-button w3-hover-red w3-xlarge w3-display-topright">&times;</span>
                    <div class="w3-modal-content w3-animate-zoom">
                        {/* <!-- <img id="img01" style="width:100%"> --> */}
                        <div style={{ padding: '56.25% 0 0 0', position: 'relative' }}><iframe id="img01" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }} title="Smart Waste Management System_Without Music_V02"></iframe></div>
                    </div>
                </div>
                {/* <!-- Modal-section End --> */}
                {/* <!-- Begin About section --> */}
                <div class="android-more-section">
                    <div class="android-section-title mdl-typography--display-1-color-contrast">About Grok Learning:</div>
                    <div style={{ marginLeft: "12px" }}>
                        <p>
                            Grok Learning bridges the gap between the current education system and real-world requirements.
                        </p>
                        <p>
                            Using the Grovator Platform, Grok is teaching students to Apply Academic Concepts using the Latest Technologies to Solve Real-World Problems. Connecting our education system to the changing real world and keeping it relevant to the changing times.
                            <br /><br />
                        </p>
                        <p>Grovator Platform :</p>
                        <p>
                            The Grovator® Applied Learning Platform is the next-gen Al-based Super Teacher. Grovator® nurtures the spirit of innovation in young minds and helps students assimilate fundamental academic concepts through an applied learning approach. It helps develop analytical skills and a problem-solving mindset. Grovator® enables building solutions for new industry problems using the latest technology such as IoT, 3D Printing, Data Science, Robotics, and AI. Grovator® comprises innovative knowledge modules, software tools, and hardware kits and follows a learning methodology with 30% theory and 70% practical.
                            <br /><br />
                        </p>
                        <p>Grok Learning for Schools and Colleges:</p>
                        <p>
                            Grok Learning builds on the innate curiosity of young minds, provides them with technology to help explore the concepts learned in school, and tools and knowledge to build solutions to real-world problems.
                        </p>
                        <p>
                            Grovator® nurtures the spirit of innovation in young minds develops analytical skills and a problem-solving mindset and develops leadership skills to become job creators and innovators.
                        </p>
                    </div>
                </div>
                {/* <!-- End About Section --> */}
                <footer class="android-footer mdl-mega-footer">
                    <div class="mdl-mega-footer--top-section">
                        <div class="mdl-mega-footer--left-section">
                            {/* <!-- <button class="mdl-mega-footer--social-btn"></button>
                                        &nbsp;
                                        <button class="mdl-mega-footer--social-btn"></button>
                                        &nbsp;
                                    <button class="mdl-mega-footer--social-btn"></button> --> */}
                        </div>
                        <div class="mdl-mega-footer--right-section">
                            <a class="mdl-typography--font-light" href="#top">
                                Back to Top
                                <i class="material-icons">expand_less</i>
                            </a>
                        </div>
                    </div>

                    <div class="mdl-mega-footer--middle-section">
                        <p class="mdl-typography--font-light">Grok Learning Pvt LTD © 2024</p>
                        {/* <!-- <p class="mdl-typography--font-light">Some more copy right or footer text</p> --> */}
                    </div>

                    {/* <!-- <div class="mdl-mega-footer--bottom-section">
                            <a class="android-link android-link-menu mdl-typography--font-light" id="version-dropdown">
                            More Footer Links
                            <i class="material-icons">arrow_drop_up</i>
                            </a>
                            <ul class="mdl-menu mdl-js-menu mdl-menu--top-left mdl-js-ripple-effect" for="version-dropdown">
                            <li class="mdl-menu__item">Link 1</li>
                            <li class="mdl-menu__item">Link 2</li>
                            <li class="mdl-menu__item">Link 3</li>
                            <li class="mdl-menu__item">Link 4</li>
                            </ul>
                            <a class="android-link android-link-menu mdl-typography--font-light" id="developers-dropdown">
                            Helpful links For Participants
                            <i class="material-icons">arrow_drop_up</i>
                            </a>
                            <ul class="mdl-menu mdl-js-menu mdl-menu--top-left mdl-js-ripple-effect" for="developers-dropdown">
                            <li class="mdl-menu__item">Link 1</li>
                            <li class="mdl-menu__item">Link 2</li>
                            <li class="mdl-menu__item">Link 3</li>
                            <li class="mdl-menu__item">Link 4</li>
                            </ul>
                            <a class="android-link mdl-typography--font-light" href="">Blog</a>
                            <a class="android-link mdl-typography--font-light" href="">Privacy Policy</a>
                        </div> --> */}
                </footer>


            </div>
        </div>
    )
}

export default HackathonCollege; 